import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";

// Definimos el tipo de estado para `interactiveSimulation`
interface InteractiveSimulationState {
  data: Record<string, any>;
}

// Estado inicial de `interactiveSimulation`
const initialState: InteractiveSimulationState = {
  data: {},
};

const interactiveSimulationSlice = createSlice({
  name: "interactiveSimulation",
  initialState,
  reducers: {
    setData(state, action: PayloadAction<Record<string, any>>) {
      state.data = action.payload;
    },
  },
});

export const { setData } = interactiveSimulationSlice.actions;
export default interactiveSimulationSlice.reducer;

// Thunk para establecer los datos de la simulación interactiva
export const setInteractiveSimulationData =
  (payload: Record<string, any>) => async (dispatch: AppDispatch) => {
    dispatch(setData(payload));
  };
